import { render, staticRenderFns } from "./exportStudentDialog.vue?vue&type=template&id=0637bac2&"
import script from "./exportStudentDialog.vue?vue&type=script&lang=js&"
export * from "./exportStudentDialog.vue?vue&type=script&lang=js&"
import style0 from "./exportStudentDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports